"use client";

import { type RefObject, useEffect, useRef } from "react";
import { scrollEditableFieldIntoView } from "./scroll";

/**
 * When `active` becomes true (e.g. pencil → edit), smoothly scroll the field
 * into view. Pair with {@link useFocusEditableControlWhen} for focus.
 */
export function useScrollEditableFieldIntoViewWhen(
	active: boolean,
	ref: RefObject<HTMLElement | null>,
): void {
	const wasActiveRef = useRef(false);

	useEffect(() => {
		if (!active) {
			wasActiveRef.current = false;
			return;
		}
		if (wasActiveRef.current) {
			return;
		}
		wasActiveRef.current = true;

		const id = requestAnimationFrame(() => {
			scrollEditableFieldIntoView(ref.current);
		});
		return () => cancelAnimationFrame(id);
	}, [active, ref]);
}
